export const clamp = (val: number, min: number, max: number): number =>
  Math.max(min, Math.min(max, val));

export const round = (
  val: number,
  allowDecimals: boolean,
  precision: number
): number => {
  if (!allowDecimals) {
    return Math.round(val);
  }

  const factor = 10 ** precision;

  return Math.round(val * factor) / factor;
};

export const formatExternal = (
  val: number | undefined,
  allowDecimals: boolean,
  precision: number
): string => {
  if (val === undefined) {
    return '';
  }

  return String(round(val, allowDecimals, precision));
};
